import React from '../helpers/react'
import { connect } from '../helpers/composeReducer.js';
import Loader from './Loader.js';
import { pushPath } from 'redux-simple-router';
import {getHookClass} from '../helpers/cssHooks.js';
import classList from 'ereader-core/dist/classList';

export const ToolbarNavigation = React.createClass({

    gotoProblem : function() {
        this.props.pushPath(this.props.buildRoute('problem',{
            chapter : this.refs.tocChapterList.value,
            problem : this.refs.tocProblemList.value,
            isbn13  : this.props.isbn13
        }));
    },

    selectChapter : function(){
        this.props.pushPath(this.props.buildRoute('chapter',{
            chapter : this.refs.tocChapterList.value,
            isbn13  : this.props.isbn13
        }));
    },

    getChapters : function(){
        if (!this.props.params.chapter || !this.props.chapter_stack.length) return;

        let id_key = this.props.use_id_identifier ? 'id' : 'name';
        let current_chapter_id = this.props.params.chapter;

        let chapters = this.props.chapter_stack.map((chapter) => {
            let id = chapter[id_key];

            if(!chapter.problems.length) {
              return '';
            }

            return  <option key={'toc-chapter' + id}
                            value={id}
                            data-id={id}>
                        {this.props.getDef('toc.chapter.name', {name : chapter.name})}
                    </option>;
        });

        return  <section className='nav-control'
                         key='toc-chapter-list'>
                    <select value={current_chapter_id}
                            ref='tocChapterList'
                            className='chapter-list'
                            onChange={this.selectChapter}>
                        {chapters}
                    </select>
                </section>;
    },

    getProblems : function() {
        if (!this.props.params.problem || !this.props.chapter_stack.length) return;

        let id_key = this.props.use_id_identifier ? 'id' : 'name';
        let current_problem_id = this.props.params.problem;
        let current_chapter_id = this.props.params.chapter;
        let current_chapter = {};

        if (this.props.use_id_identifier) {
            current_chapter = this.props.chapters[current_chapter_id];
        } else {
            current_chapter = this.props.chapter_stack.find((chapter) => {
                return chapter[id_key] == current_chapter_id;
            });
        }

        let problems = current_chapter.problems.map((problem) => {
            let id = problem[id_key];

            return   <option key={'toc-problem' + id}
                             value={id}
                             data-id={id}>
                        {this.props.getDef('toc.problem.name', {name : problem.name})}
                    </option>;
        });

        return  <section className='nav-control'
                         key='toc-problem-list'>
                    <select value={current_problem_id}
                            ref='tocProblemList'
                            className='problem-list'
                            onChange={this.gotoProblem}>
                        {problems}
                    </select>
                </section>;
    },

    getLoader : function() {
        return  <span className='toc-loader'
                      key='toc-loader'>
                    {Loader('loader')}
                    {this.props.getDef('toc.loader.title')}
                </span>;
    },

    render : function() {
        const loader = this.getLoader(),
            chapters = this.getChapters(),
            problems = this.getProblems(),
            title = <h3 key='toolbar-title' className='title'>{this.props.getDef('header.title')}</h3>,
            result = [];

        if (!this.props.chapter_stack.length) {
            result.push(loader);
        } else {
            //result.push(title)
            result.push(chapters);
            result.push(problems);
        }
        let mainClass = classList('ToolbarNavigation', getHookClass('ToolbarNavigation'));

        return  <section className={mainClass}>
                    {result}
                </section>;
    }

});

export const mapStateToProps = function(state) {
    return {
        isbn13 : state.model.isbn13,
        chapter_stack : state.toc.chapter_stack,
        chapters : state.toc.chapters,
        use_id_identifier : state.options.use_id_identifier,
        buildRoute : state.helpers.buildRoute,
        getDef : state.helpers.getDef
    }
};

export default connect(mapStateToProps, {
    pushPath
})(ToolbarNavigation);



// WEBPACK FOOTER //
// ./src/components/ToolbarNavigation.js